import React from 'react'

import { Spin, Icon } from 'antd'

import './index.less'

export const Spinner = () => {
  return (
    <div id='loading-list'>
      <Spin
        size='large'
        indicator={<Icon type='loading' style={{ fontSize: 24 }} spin />}
      />
    </div>
  )
}
